export const LogoMark = ({ size = 44, className = "" }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        className={className}
        role="img"
        aria-label="Little Seeds Flourish logo — a seedling growing from a terracotta pot into a yellow flower"
    >
        <rect x="2" y="2" width="60" height="60" rx="22" fill="#8FB38A" />
        <rect x="25" y="47" width="14" height="7" rx="2.5" fill="#E07A5F" />
        <rect x="23" y="44" width="18" height="5.5" rx="2.75" fill="#D0684D" />
        <path d="M32 45V27" stroke="#3D3229" strokeWidth="3.5" strokeLinecap="round" />
        <path d="M32 39c-7.5 1-11-2.2-12-7.6 6.6-1.1 10.9 2 12 7.6z" fill="#FFF8EC" />
        <path d="M32 35.5c5.4-4.4 10.8-4.4 14.2-1-3.2 4.3-8.6 5.2-14.2 1z" fill="#FFF8EC" />
        <circle cx="32" cy="13.5" r="3.2" fill="#E07A5F" />
        <circle cx="40" cy="19" r="3.2" fill="#E07A5F" />
        <circle cx="37" cy="28.3" r="3.2" fill="#E07A5F" />
        <circle cx="27" cy="28.3" r="3.2" fill="#E07A5F" />
        <circle cx="24" cy="19" r="3.2" fill="#E07A5F" />
        <circle cx="32" cy="21" r="4.6" fill="#F6C544" />
    </svg>
);

export const Logo = ({ light = false, size = 44 }) => (
    <span className="inline-flex items-center gap-2.5">
        <LogoMark size={size} />
        <span className="leading-none text-left">
            <span className={`block font-display font-semibold text-lg ${light ? "text-cream" : "text-soil"}`}>Little Seeds</span>
            <span className={`block text-[10px] font-extrabold tracking-[0.32em] mt-0.5 ${light ? "text-sun" : "text-coral"}`}>FLOURISH</span>
        </span>
    </span>
);
